export const ProjectData = [
  {
    id: 1,
    title: "Game Hosting Application",
    about:
      " As part of a collaborative effort, I contributed to the development of ESAN, a dynamic Game Hosting Application that revolutionizes the way gaming tournaments are managed and enjoyed. ESAN seamlessly blends cutting-edge technology with a user-friendly interface to create an immersive experience for both players and organizers.",
    tags: ["NextJS", "Typescript"],
    demo: "https://dev-esan-fe.vercel.app/",
    github: "",
    image: "/esan.png",
  },
  {
    id: 1,
    title: "My Condo Pro",
    about:
      "My Condo Pro is an Condo online selling website. It is a platform where you can buy, rent, and sell your condos. ",
    tags: ["ReactJS", "Bootstrap"],
    demo: "https://my-condo.vercel.app/",
    image: "/mycondopro.png",
    github: "",
  },
  {
    id: 1,
    title: "E-Commerce Website",
    about:
      "Dmerce, an innovative E-commerce website dedicated to showcasing my own clothing startup brand, I embarked on a journey to seamlessly blend fashion and technology. Dmerce redefines online shopping by offering a captivating and personalized experience that reflects the essence of my brand.",
    tags: ["NextJS", "Material UI"],
    demo: "https://dmerce.vercel.app/",
    image: "/dmerce.png",
    github: "",
  },
  {
    id: 1,
    title: "Company's Website",
    about:
      " This was a very simple website I built it for a company that I am currently working, Baliyo Venture.",
    tags: ["ReactJS", "CSS"],
    demo: "https://www.baliyoventures.com/",
    image: "/baliyo.png",
    github: "",
  },
];
